var zxcvbn = require('zxcvbn');

var labels = ['Sehr schwach', 'Schwach', 'Akzeptabel', 'Gut', 'Stark'];
var colors = [
    'ui-password-strength-danger',
    'ui-password-strength-danger',
    'ui-password-strength-danger',
    'ui-password-strength-warning',
    'ui-password-strength-success'
];

function asElements(input) {
    if (!input) {
        return [];
    }

    if (input.jquery) {
        return input.toArray();
    }

    if (input instanceof Element) {
        return [input];
    }

    return Array.prototype.slice.call(input);
}

function createMeter(viewport) {
    viewport.setAttribute('role', 'progressbar');
    viewport.setAttribute('aria-valuemin', '0');
    viewport.setAttribute('aria-valuemax', '4');
    viewport.classList.remove('mt-2', 'h-2', 'overflow-hidden', 'rounded', 'bg-gray-200');
    viewport.classList.add('ui-password-strength-meter');

    var indicator = viewport.querySelector('[data-password-strength-indicator]');
    if (!indicator) {
        indicator = document.createElement('span');
        indicator.dataset.passwordStrengthIndicator = 'true';
        indicator.className = 'ui-password-strength-indicator';
        viewport.replaceChildren(indicator);
    }

    return indicator;
}

function updateMeter(input, viewport, indicator) {
    var result = zxcvbn(input.value || '');
    var score = Math.max(0, Math.min(4, result.score || 0));
    var width = input.value ? Math.max(5, (score + 1) * 20) : 1;

    indicator.className = 'ui-password-strength-indicator ' + colors[score];
    indicator.style.width = String(width) + '%';
    viewport.setAttribute('aria-valuenow', String(input.value ? score : 0));
    viewport.setAttribute('aria-valuetext', input.value ? labels[score] : 'Keine Eingabe');
}

module.exports = function pwdStrength(input) {
    asElements(input).forEach(function (element) {
        if (element.dataset.passwordStrengthReady === 'true') {
            return;
        }

        element.dataset.passwordStrengthReady = 'true';
        var scope = element.closest('#pwdContainer') || document;
        var viewport = scope.querySelector('.pwstrength_viewport_progress');
        if (!viewport) {
            return;
        }

        var indicator = createMeter(viewport);
        var refresh = function () {
            updateMeter(element, viewport, indicator);
        };
        element.addEventListener('input', refresh);
        element.addEventListener('change', refresh);
        refresh();
    });
};
